import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import '../CSS/Global.css';
import Header from "./Header";
import Sidebar from "./SideBar";
import { useSidebar } from "../SidebarContext";
import { toast } from "react-toastify";

function ListHomeCategory() {
    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [selectedMovies, setSelectedMovies] = useState([]);
    const [allMovies, setAllMovies] = useState([]);
    const [category, setCategory] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const { id } = useParams();
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const { isSidebarOpen } = useSidebar();
    const [residentData, setResidentData] = useState([]);
    const [commData, setCommData] = useState([]);
    const [rentData, setRentData] = useState([]);

    const BASE_URL = "https://100real.xyz";
    useEffect(() => {
        const fetchCatgeoryViaID = async () => {
            try {
                const response = await axios.get(`https://100real.xyz/category/single/${id}/${isLoggedIn.user_id}`);
                setCategory(response.data.category);
                setSelectedMovies(JSON.parse(response.data.buildings) || []);
            } catch (error) {
                toast.error("Error fetching category data", {
                    position: "top-center",
                    autoClose: 2000,
                })
            }
        };
        fetchCatgeoryViaID();
    }, [id]);

    const parseProps = (item) => {
        const parseJSON = (val) => {
            try {
                return typeof val === 'string' ? JSON.parse(val) : val;
            } catch {
                return val;
            }
        };

        return {
            amenities: parseJSON(item.amenities || "[]"),
            carpetArea: parseJSON(item.carpetArea || "[]"),
            flatType: parseJSON(item.flatType || "[]"),
            expectedPrice: parseJSON(item.expectedPrice || "[]"),
            formImages: parseJSON(item.formImages || "[]"),
            locationAdvantages: parseJSON(item.locationAdvantage || item.locationAdvantages || "[]"),
        };
    };


    const fetchResData = async () => {
        const res = await fetch(`${BASE_URL}/resident/getproperty/${isLoggedIn.user_id}`);
        const json = await res.json();
        const parsed = json.map(item => ({ ...item, type: "resident", ...parseProps(item) }));
        setResidentData(parsed);
    };

    const fetchCommData = async () => {
        const res = await fetch(`${BASE_URL}/commercial/getproperty/${isLoggedIn.user_id}`);
        const json = await res.json();
        const parsed = json.map(item => ({ ...item, type: "commercial", ...parseProps(item) }));
        setCommData(parsed);
    };

    const fetchRentData = async () => {
        const res = await fetch(`${BASE_URL}/rentresident/getproperty/${isLoggedIn.user_id}`);
        const json = await res.json();
        const parsed = json.map(item => ({ ...item, type: "rent", ...parseProps(item) }));
        setRentData(parsed);
    };
    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await axios.get(`https://100real.xyz/property/getproperty/${isLoggedIn.user_id}`);
    //             const parsedData = response.data.map((item) => ({
    //                 ...item,
    //                 available_amenities: item.available_amenities ? JSON.parse(item.available_amenities) : null,
    //                 flatType: item.flatType ? JSON.parse(item.flatType) : null,
    //                 formImages: item.formImages ? JSON.parse(item.formImages) : null,
    //                 over_lookings: item.over_lookings ? JSON.parse(item.over_lookings) : null,
    //                 securityFeatures: item.securityFeatures ? JSON.parse(item.securityFeatures) : null,
    //                 water_supply: item.water_supply ? JSON.parse(item.water_supply) : null,
    //             }));
    //             setAllMovies(parsedData);
    //         } catch (error) {
    //             toast.error("Error fetching data", {
    //                 position: "top-center",
    //                 autoClose: 2000,
    //             })
    //         }
    //     };
    //     fetchData();
    // }, []);

    useEffect(() => {
        fetchResData();
        fetchCommData();
        fetchRentData();
    }, []);

    // const combinedData = [...residentData, ...commData, ...rentData];
    // const uniqueData = combinedData.filter(
    //     (value, index, self) =>
    //         index === self.findIndex((t) => t.property_id === value.property_id)
    // );

    const uniqueData = useMemo(() => {
        const combined = [...residentData, ...commData, ...rentData];
        return combined.filter(
            (value, index, self) =>
                index === self.findIndex((t) => t.property_id === value.property_id)
        );
    }, [residentData, commData, rentData]);

    useEffect(() => {
        if (searchTerm) {
            const filtered = uniqueData.filter(movie =>
                movie.building_name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setSuggestions(filtered);
        } else {
            setSuggestions([]);
        }
    }, [searchTerm, uniqueData]);

    

    const handleSuggestionClick = (movie) => {
        // Check if the movie already exists in selectedMovies
        if (selectedMovies.some(item => item.property_id === movie.property_id)) {
            toast.info("This property is already in your selected list!", {
                position: "top-center",
                autoClose: 2000,
            });
            
        } else {
            // Add movie to the selectedMovies list
            setSelectedMovies([...selectedMovies, movie]);
        }
        setSearchTerm("");
        setSuggestions([]);
    };
    
    const handleRemoveMovie = (movieToRemove) => {
        setSelectedMovies(selectedMovies.filter(movie => movie.id !== movieToRemove.id));
    };

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(selectedMovies);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setSelectedMovies(items);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://100real.xyz/category/change-category/${id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    buildings: selectedMovies,
                    category,
                    user_id: isLoggedIn.user_id
                })
            });
            const res = await response.json();
            if (response.ok) {
                toast.success("Category updated successfully!", {
                    position: "top-center",
                    autoClose: 2000,
                });
            }
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 3000);
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000,
            });

        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Update Category</h1>

                    {/* Add Offers Button */}
                    {/* <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Category
                    </button> */}
                </div>
                <div className="category-container">
                    {/* {showAlert && <div className="custom-alert">✅ Changes saved successfully</div>} */}
                    {/* <h2>Update Category</h2> */}
                    <form onSubmit={handleSubmit}>
                        <label className="headlabel-hbthome">Search Property</label>
                        <input
                            type="text"
                            value={searchTerm}
                            className="headinput-hbthome"
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onBlur={() => setTimeout(() => setSuggestions([]), 100)}
                        />
                        {suggestions.length > 0 && (
                            <ul className="suggestions-list">
                                {suggestions.map((movie) => (
                                    <li key={movie.id} onMouseDown={() => handleSuggestionClick(movie)}>
                                        <img
                                            src={`https://100real.xyz/Images/Store/${movie.formImages[0]}`}
                                            alt={movie.building_name}
                                        />
                                        {movie.building_name}
                                    </li>
                                ))}
                            </ul>
                        )}
                        <label className="headlabel-hbthome">Category Name</label>
                        <input
                            type="text"
                            value={category}
                            className="headinput-hbthome"
                            onChange={(e) => setCategory(e.target.value)}
                            required
                        />
                        <label className="headlabel-hbthome">Selected Properties</label>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="selectedMovies" direction="horizontal">
                                {(provided) => (
                                    <div className="selected-movies" ref={provided.innerRef} {...provided.droppableProps}>
                                        {selectedMovies.map((movie, index) => (
                                            <Draggable key={movie.id} draggableId={movie.id.toString()} index={index}>
                                                {(provided) => (
                                                    <div
                                                        className="movie-chip"
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        {movie.building_name}
                                                        <button onClick={() => handleRemoveMovie(movie)}>×</button>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                        <button type="submit" className="submit-btn">Submit</button>
                    </form>
                </div>
            </div>
        </>
    );
}

export default ListHomeCategory;
